import mergeClasses from '../../../utils/shallowMerge';
import { Image as CustomImage } from '../../atoms/image/Image';
import defaultClasses from './Swatches.module.scss';
import transitionClass from './Transtion.module.scss';
import clsx from 'clsx';
import React, { useState } from 'react';
import { CSSTransition } from 'react-transition-group';

const SwatchesItem = ({ imageUrl, colorAttribute, url, colorIndex, customClasses }) => {
  const [colorTooltip, setTooltip] = useState(false);
  const styles = mergeClasses(defaultClasses, customClasses);

  return (
    <li
      style={{
        position: 'relative',
      }}
      data-status={colorAttribute === colorIndex ? 'active' : 'no_active'}
      className={clsx({
        [styles.activeColour]: colorAttribute === colorIndex,
      })}
      onClick={() => {
        if (url) {
          if (typeof window !== 'undefined') {
            window.location.href = url;
          }
        }
      }}
      onMouseOver={() => {
        setTooltip(true);
      }}
      onMouseLeave={() => {
        setTooltip(false);
      }}
    >
      <CustomImage
        alt={colorAttribute}
        image={imageUrl}
        style={{
          fontSize: '0',
        }}
        remote={false}
        opts={{
          width: 52,
          height: 52,
          sirvWidth: 56,
          sirvHeight: 70,
        }}
      />
      <CSSTransition classNames={transitionClass} in={colorTooltip} timeout={400} unmountOnExit>
        <p className={styles.tooltip}>{colorAttribute}</p>
      </CSSTransition>
    </li>
  );
};

export default SwatchesItem;
